<template>
  <CockpitCard cardType="default">
    <TableButtonGroup
      :list="deviceList"
      v-model="deviceName"
      class="my-10px"
      @btn-click="deviceClick"
    />
    <el-input
      placeholder="请输入关键词"
      v-model="keyWord"
      size="small"
      clearable
      @keypress.enter.native="getTableData()"
      class="icon-search__input mb-10px"
    >
      <i
        slot="append"
        class="el-icon-search cursor-pointer icon-search__input"
        @click="getTableData()"
      ></i>
    </el-input>
    <div class="!h-[calc(100%-140px)] !w-full">
      <el-table :data="tableData" highlight-current-row v-loading="tableLoading" height="100%">
        <el-table-column label="" width="15">
          <template>
            <div class="selected-row"></div>
          </template>
        </el-table-column>
        <el-table-column label="设备名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备状态">
          <template slot-scope="{ row }">
            <div :class="row.status === '0' ? 'text-hex-fc0f0f' : 'text-hex-11d45f'">
              {{ row.status === 0 ? '正常' : '异常' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <div @click="lookDetail(row)" class="cursor-pointer text-hex-00bcc8">查看</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      small
      background
      @size-change="getTableData()"
      @current-change="getTableData()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="page.total"
      class="text-center my-10px"
    ></el-pagination>
  </CockpitCard>
</template>

<script>
// tools
import { find, get } from 'lodash'
import { transferSkipCount } from '@/assets/js/TransferPage'
// components
import CockpitCard from '@/components/cockpit/CockpitCard'
// api
import {
  RackApi,
  ComputerApi,
  ExchangeBoardApi,
  PositionStationApi,
  CommunicationStationApi,
} from '@wiz-api/huizhou2-business'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import TableButtonGroup from './NewTabButton'

const rackApi = new RackApi()
const computerApi = new ComputerApi()
const exchangeBoardApi = new ExchangeBoardApi()
const positionStationApi = new PositionStationApi()
const communicationStationApi = new CommunicationStationApi()
const iOTDeviceApi = new IOTDeviceApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  components: { TableButtonGroup, CockpitCard },
  data() {
    return {
      deviceList: ['服务器', '交换机', '机柜', '定位基站', '门禁', '摄像头', '5G基站'],
      deviceName: '定位基站',
      deviceBtnList: [
        { name: '服务器', type: 'computer' },
        { name: '交换机', type: 'exchangeBoard' },
        { name: '定位基站', type: 'positionStation' },
        { name: '机柜', type: 'rack', api: 'rackApi' },
        { name: '5G基站', type: 'communicationStation' },
        { name: '门禁', type: 'access' },
        { name: '摄像头', type: 'camera' },
      ],
      keyWord: '',
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      visible: false,
      title: '',
      factureMap: {},
    }
  },
  methods: {
    async getTableData() {
      this.tableLoading = true
      switch (this.deviceType) {
        case 'computer': // 服务器
          const [computerErr, computerRes] = await computerApi.getList({
            keyWord: this.keyWord,
            sorting: '',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!computerErr) {
            this.tableData = computerRes.items
            this.page.total = computerRes.totalCount
            this.tableLoading = false
          }
          break

        case 'exchangeBoard': // 交换机
          const [exchangeBoardErr, exchangeBoardRes] = await exchangeBoardApi.getList({
            keyWord: this.keyWord,
            sorting: '',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!exchangeBoardErr) {
            this.tableData = exchangeBoardRes.items
            this.page.total = exchangeBoardRes.totalCount
            this.tableLoading = false
          }
          break

        case 'positionStation': // 定位基站
          const [positionStationErr, exchangeBoardResRes] = await positionStationApi.getList({
            keyWord: this.keyWord,

            sorting: '',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!positionStationErr) {
            this.tableData = exchangeBoardResRes.items
            this.page.total = exchangeBoardResRes.totalCount
            this.tableLoading = false
          }
          break

        case 'rack': // 机柜
          const [rackErr, rackRes] = await rackApi.getList({
            keyWord: this.keyWord,
            sorting: '',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!rackErr) {
            this.tableData = rackRes.items
            this.page.total = rackRes.totalCount
            this.tableLoading = false
          }
          break

        case 'communicationStation': // 通信基站 ---就是5G基站
          const [comStationErr, comStationRes] = await communicationStationApi.getList({
            keyWord: this.keyWord,
            sorting: '',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!comStationErr) {
            this.tableData = comStationRes.items
            this.page.total = comStationRes.totalCount
            this.tableLoading = false
          }
          break
        case 'access': // 门禁
          const [accessErr, accessRes] = await iOTDeviceApi.getDeviceWithDetailPageList({
            keyWord: this.keyWord,
            deviceTypeCode: 'AccessControl',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!accessErr) {
            this.tableData = accessRes.items.map((it) => {
              it.statusText = it.status
              it.newDeviceType = it.deviceType
              it.status = 0
              return it
            })
            this.page.total = accessRes.totalCount
            this.tableLoading = false
          }
          break
        case 'camera': // 摄像头
          const [cameraErr, cameraRes] = await iOTDeviceApi.getDeviceWithDetailPageList({
            keyWord: this.keyWord,
            deviceTypeCode: 'Camera',
            skipCount: transferSkipCount(this.page.pageNo, this.page.pageSize),
            maxResultCount: this.page.pageSize,
          })
          if (!cameraErr) {
            this.tableData = cameraRes.items.map((it) => {
              it.statusText = it.status
              it.newDeviceType = it.deviceType
              it.status = 0
              return it
            })
            this.page.total = cameraRes.totalCount
            this.tableLoading = false
          }
          break

        default:
          break
      }
    },
    lookDetail(row) {
      if (this.deviceName === '门禁' || this.deviceName === '摄像头') {
        row.facturer = this.factureMap[row.manufacturerCode] || row.manufacturerCode
        if (row.statusText === 1) {
          row.statusText = '在线'
        } else if (row.statusText === 2) {
          row.statusText = '离线'
        } else {
          row.statusText = '未知'
        }
      }
      this.$emit('showDetail', { ...row, deviceName: this.deviceName, deviceType: this.deviceType })
    },
    async deviceClick(name) {
      this.deviceName = name
      await this.getTableData()
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer'],
        includeDetails: true,
      })
      if (!err && res && res.length && res[0].dataItems && res[0].dataItems.length) {
        let facturerList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') {
            facturerList = item.dataItems
          }
        })
        this.factureMap = facturerList.reduce((per, cur) => {
          per[cur.code] = cur.displayName
          return per
        }, {})
      }
    },
  },
  created() {
    this.getCategoryByCodes()
  },
  props: {
    platformRightData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    deviceType() {
      return get(find(this.deviceBtnList, { name: this.deviceName }), 'type') || ''
    },
  },
  watch: {
    platformRightData: {
      async handler(val) {
        this.deviceName = get(val, 'name')
        await this.getTableData()
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
</style>
